import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../hoc/Loading/Loading";
import axios from "../../axios";
import * as actionCreators from "../../modules/actions/index";
import { connect } from "react-redux";
import LinkedToolItem from "./LinkedToolItem";
import * as url from "../../utils/url";
import { Container, Row, Col, Table } from "reactstrap";
import moment from "moment";
// toolkitCategories
import { toolkitCategories } from "../../utils/categories";

class LinkedTools extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tools: this.props.tools,
      linkedTools: this.props.linkedTools,
    };
  }

  getAttachedItems = tool => {
    let { linkedTools, taskId } = tool;
    let link_ids = linkedTools.map(e => e.itemId);
    let payload = {
      linkedTools: link_ids,
      taskId,
      category: "All",
    };

    if (linkedTools && linkedTools.length > 0) {
      axios.post(url.fetchAttachedTools, payload).then(({ data }) => {
        let result = data.data;
        let mod = result.map(e => {
          let other = linkedTools.find(
            el => el.itemId.toString() == e._id.toString()
          );
          return { attachedDate: other.date, ...e };
        });
        this.setState({ tools: mod });
      });
    }
  };

  componentDidMount() {
    this.getAttachedItems(this.props);
  }

  componentDidUpdate(prevProps, prevState) {
    let current_ch = JSON.stringify(prevProps.linkedTools);
    let prev_ch = JSON.stringify(this.props.linkedTools);
    if (current_ch != prev_ch) {
      this.getAttachedItems(this.props);
    }
  }

  viewTool = tool => {
    let { category } = tool;
    let tool_cat = toolkitCategories.filter(e => e.name == category)[0];
    let tool_link = `/home/toolkit/${tool_cat.link}/tool/${tool._id}`;
    this.props.history.push(tool_link);
  };

  renderView = () => {
    let { tools } = this.state;
    if (tools && tools.length > 0) {
      return (
        <div className="singleTaskToolkitTableContainerBox">
          <Table responsive hover className="taskToolkitTable">
            <thead>
              <tr>
                <th>Name</th>
                <th>Category</th>
                {/* <th>Created By</th> */}
                <th>Date Linked</th>
              </tr>
            </thead>
            <tbody>
              {tools.map((e, idx) => {
                let tool = e;
                return (
                  <React.Fragment key={idx + e._id}>
                    <tr className="linkedToolTable" key={tool._id}>
                      <td>
                        {tool.name}{" "}
                        <span
                          className="linkedToolView"
                          onClick={() => this.viewTool(tool)}
                        >
                          (view)
                        </span>
                      </td>

                      <td>{tool.category}</td>

                      {/* <td >
                                   test 13                    
                                </td> */}

                      <td>
                        {moment(tool.attachedDate).format("MMM Do, YYYY")}
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </Table>
        </div>
      );
    } else {
      return null;
    }
  };

  render() {
    return this.renderView();
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(LinkedTools, axios)));
